<template>
  <div>
    <div class="option_header">
      <div class="header_title">
        <div class="title_left">增值税发票税控开票软件（金税盘版）V2.0.42_ZS_20210430</div>
        <div class="title_right">
          <div>9135020679297886N.0</div>
          <div>地区：350200</div>
        </div>
      </div>
      <div class="header_op">
        <div class="op_left">
          <div
            class="op_item"
            :class="headerNavIdx === index ? 'active' : ''"
            v-for="(item, index) in leftImgs"
            :key="index"
            @click="toComp(item.compName, index)"
          >
            <img :src="item.iconSrc" alt="" />
            <span>{{ item.title }}</span>
          </div>
        </div>
        <div class="op_right">
          <div class="op_item" v-for="(item, index) in rightImgs" :key="index">
            <img :src="item.iconSrc" alt="" />
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
      <div class="header_nav">
        <a-menu v-model="current" mode="horizontal">
          <a-sub-menu v-for="(navItem, index) in navs" :key="index">
            <span slot="title" class="submenu-title-wrapper">{{ navItem.name }}</span>
            <a-menu-item-group v-if="navItem.navChilds && navItem.navChilds.length">
              <a-menu-item v-for="navChild in navItem.navChilds" :key="navChild.key" @click="navClick(navChild.type)"
                >{{ navChild.name }}
              </a-menu-item>
            </a-menu-item-group>
          </a-sub-menu>
        </a-menu>
        <!-- <span class="nav_item" v-for="(navItem, index) in navs" :key="index" @click="openCompDetail()">{{
          navItem.name
        }}</span> -->
      </div>
    </div>
    <div style="height: 45px; width: 100%">
      <!-- 占位 -->
    </div>
    <div class="option_main">
      <div class="main_wrap">
        <component :is="compName" ref="compName" @setInvoiceType="setInvoiceType"></component>
      </div>
    </div>
  </div>
</template>

<script>
// import Urls from '@/utils/globel.js'
import systemSet from '../systemSet/Index.vue'
import ticketsManage from '../ticketsManage/Index.vue'
import invoiceManage from '../invoiceManage/Index.vue'
import sumProcess from '../sumProcess/Index.vue'
import systemMaintain from '../systemMaintain/Index.vue'
const navList = {
  systemSet: [
    {
      name: '初始设置',
      navChilds: [
        { name: '初始化', key: '初始化' },
        { name: '参数设置', key: '参数设置' },
        { name: '系统注册', key: '系统注册' },
        { name: '电子发票公共服务平台申请', key: '电子发票公共服务平台申请' },
        { name: '电子发票公共服务平台撤销', key: '电子发票公共服务平台撤销' },
      ],
    },
    {
      name: '用户权限设置',
      navChilds: [
        { name: '用户管理', key: '用户管理' },
        { name: '角色管理', key: '角色管理' },
      ],
    },
    {
      name: '编码管理',
      navChilds: [
        { name: '客户编码', key: '客户编码', type: 'customNo' },
        { name: '商品编码', key: '商品编码', type: 'goodsNo' },
        { name: '税收编码', key: '税收编码', tpye: 'taxNo' },
      ],
    },
  ],
  ticketsManage: [
    {
      name: '网上申领管理',
      navChilds: [{ name: '发票申领管理', key: '发票申领管理', type: 'wssl' }],
    },
    {
      name: '网上领票管理',
      navChilds: [
        { name: '领用发票', key: '领用发票', type: 'wslp' },
        { name: '领用票量查询', key: '领用票量查询', type: 'lyplcx' },
      ],
    },
    {
      name: '网上分票管理',
      navChilds: [{ name: '领用状态查询', key: '领用状态查询' }],
    },
    {
      name: '介质领用管理',
      navChilds: [{ name: '发票读入', key: '发票读入', type: 'fpdr' }],
    },
    {
      name: '库存查询',
      navChilds: [{ name: '库存查询', key: '库存查询', type: 'fpcx' }],
    },
  ],
  invoiceManage: [
    {
      name: '发票填开',
      navChilds: [
        { name: '批量填开', key: '批量填开' },
      ],
    },
    {
      name: '发票作废',
      navChilds: [
        { name: '已开发票作废', key: '已开发票作废', type: 'invoiceToVoid' },
        { name: '未开发票作废', key: '未开发票作废' },
      ],
    },
    {
      name: '查询修复',
      navChilds: [
        { name: '已开发票查询', key: '已开发票查询', type: 'invoiceQuery' },
        { name: '发票修复', key: '发票修复' },
      ],
    },
    {
      name: '红字发票信息表',
      navChilds: [
        { name: '红字增值税专用发票信息表填开', key: '红字增值税专用发票信息表填开', type: 'infoSheetWrite' },
        { name: '红字增值税专用发票信息表维护', key: '红字增值税专用发票信息表维护', type: 'infoSheetRepair' },
      ],
    },
    {
      name: '发票参数设置',
      navChilds: [
        { name: '卷票规格设置', key: '卷票规格设置' },
        { name: '但因模板设置', key: '但因模板设置' },
      ],
    },
  ],
  sumProcess: [
    {
      name: '汇总管理',
      navChilds: [
        { name: '汇总处理', key: '1' },
        { name: '汇总资料传出', key: '2' },
        { name: '汇总上传', key: '3' },
        { name: '远程清卡', key: '4' },
      ],
    },
    {
      name: '金税设备管理',
      navChilds: [
        { name: '金税设备状态查询', key: '1' },
        { name: '金税设备时钟校准', key: '2' },
        { name: '报税盘注册', key: '3' },
      ],
    },
    {
      name: '发票资料管理',
      navChilds: [
        { name: '金税设备资料统计', key: '1' },
        { name: '发票资料查询打印', key: '2' },
        { name: '发票数据导出', key: '13' },
      ],
    },
  ],
  systemMaintain: [
    {
      name: '数据维护',
      navChilds: [
        { name: '备份与恢复', key: '1' },
        { name: '数据迁移', key: '2' },
      ],
    },
    {
      name: '变更管理',
      navChilds: [
        { name: '金税盘网上变更', key: '1' },
        { name: '报税盘网上变更', key: '2' },
      ],
    },
  ],
}
export default {
  components: {
    systemSet,
    ticketsManage,
    invoiceManage,
    sumProcess,
    systemMaintain,
  },
  data() {
    return {
      leftImgs: [
        {
          iconSrc: require('../../assets/xitongshezhi.png'),
          title: '系统设置',
          compName: 'systemSet',
        },
        {
          iconSrc: require('../../assets/piaoyuanguanli.png'),
          title: '票源管理',
          compName: 'ticketsManage',
        },
        {
          iconSrc: require('../../assets/fapiaoguanli.png'),
          title: '发票管理',
          compName: 'invoiceManage',
        },
        {
          iconSrc: require('../../assets/huizongchuli.png'),
          title: '汇总处理',
          compName: 'sumProcess',
        },
        {
          iconSrc: require('../../assets/xitongweihu.png'),
          title: '系统维护',
          compName: 'systemMaintain',
        },
      ],
      rightImgs: [
        {
          iconSrc: require('../../assets/xitongshezhi.png'),
          title: '客服',
        },
        {
          iconSrc: require('../../assets/piaoyuanguanli.png'),
          title: '帮助',
        },
        {
          iconSrc: require('../../assets/fapiaoguanli.png'),
          title: '锁屏',
        },
      ],
      headerNavIdx: 0,
      isShowNav: true,
      compName: 'systemSet',
      navList,
      current: [],
    }
  },
  computed: {
    navs() {
      return navList[this.compName]
    },
  },
  methods: {
    showNav(i) {
      this.headerNavIdx = i
    },
    toComp(compName, index) {
      this.compName = compName
      this.headerNavIdx = index
    },
    navClick(type) {
      this.$refs.compName.showChild(type)
    },
    setInvoiceType(taxClass) {
      taxClass.forEach((v) => {
        let menu
        switch (v) {
          case '0':
            menu = {
              type: 'invoiceWrite0',
              name: '增值税专用发票填开',
              key: '增值税专用发票填开',
            }
            break
          case '1':
            menu = { type: 'invoiceWrite1', name: '增值税普通发票填开', key: '增值税普通发票填开' }
            break
          case '3':
            menu = { type: 'invoiceWrite3', name: '电子发票填开', key: '电子发票填开' }
            break
        }
        this.navList.invoiceManage[0].navChilds.unshift(menu)
      })
    },
    openCompDetail() {},
  },
}
</script>

<style lang="less" scoped>
.option_header {
  height: 100px;
  background-color: #4f8cf6;
  .header_title {
    height: 20px;
    padding: 12px;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title_left {
    }
    .title_right {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 200px;
      div {
        padding: 10px;
      }
    }
  }
  .header_op {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    .op_left,
    .op_right {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .op_left {
      .op_item {
        // margin-left: 25px;
        &:hover {
          background-image: linear-gradient(#4f8cf6, #95cfff);
        }
        &.active {
          background-image: linear-gradient(#4f8cf6, #5eb2f8);
        }
      }
    }
    .op_right {
      .op_item {
        margin-right: 25px;
      }
    }
    .op_item {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      padding: 0px 20px 5px;
      cursor: pointer;
      img {
        width: 40px;
      }
      span {
        color: #fff;
        font-size: 10px;
        padding-top: 2px;
      }
    }
  }
  .header_nav {
    width: 100%;
    height: 45px;
    line-height: 45px;
    background-color: #5eb2f8;
    position: absolute;
    .nav_item {
      padding: 0 18px;
      color: #fff;
      :hover {
        background: #fcfcfc;
      }
    }
  }
}
.option_main {
  height: calc(100vh - 145px);
  background-image: url('../../assets/mainBg.png');
  background-repeat: no-repeat;
}
.main_wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: auto;
}
</style>
<style lang="less">
.ant-menu-horizontal {
  background-color: #5eb2f8;
  color: #fff;
}
.ant-menu-horizontal > .ant-menu-item:hover,
.ant-menu-horizontal > .ant-menu-submenu:hover,
.ant-menu-horizontal > .ant-menu-item-active,
.ant-menu-horizontal > .ant-menu-submenu-active,
.ant-menu-horizontal > .ant-menu-item-open,
.ant-menu-horizontal > .ant-menu-submenu-open,
.ant-menu-horizontal > .ant-menu-item-selected,
.ant-menu-horizontal > .ant-menu-submenu-selected {
  color: #fff;
}
.ant-menu-item:hover,
.ant-menu-item-active {
  color: #000;
}
.ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
.ant-menu-submenu-active,
.ant-menu-submenu-title:hover {
  color: #fff;
}
</style>
